
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class BoughtSmallCard extends Vue {
  @Prop()
  public readonly product!: any
}
